<script setup lang="ts">
import FormConvite from '../components/form-convite.vue'
import { useConviteStore } from '../store/useConviteStore'

definePage({
  meta: {
    navActiveLink: 'admin-convite',
    action: 'create',
    subject: 'convite',
  },
})

const { resetForm } = useConviteStore()

onBeforeRouteLeave(() => {
  resetForm()
})
</script>

<template>
  <FormConvite />
</template>
